import { gql } from '@urql/core';

export const USER_LIST_QUERY = gql`
  query UserList($query: RefineQueryInput) {
    users(query: $query) {
      nodes {
        id
        email
        firstName
        lastName
        isActive
        teamId
        appTeams {
          id
          name
        }
        organizationalRole
        createdAt
        updatedAt
      }
      pagination {
        current
        pageSize
        total
        totalPages
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const USER_ONE_QUERY = gql`
  query User($id: String!) {
    user(id: $id) {
      id
      email
      firstName
      lastName
      isActive
      teamId
      appTeams {
        id
        name
      }
      organizationalRole
      createdAt
      updatedAt
    }
  }
`;

export const USER_BY_AUTH_ID_QUERY = gql`
  query UserByAuthId($authId: String!) {
    userByAuthId(authId: $authId) {
      id
      email
      firstName
      lastName
      isActive
      teamId
      appTeams {
        id
        name
      }
      organizationalRole
      createdAt
      updatedAt
    }
  }
`;

export const GET_AUTH_TEAMS_QUERY = gql`
  query GetAuthTeams {
    getAuthTeams {
      id
      name
      description
      orgId
    }
  }
`;

export const GET_APP_TEAMS_QUERY = gql`
  query GetAppTeams {
    getAppTeams {
      id
      name
      description
    }
  }
`;

export const INVITE_USER_MUTATION = gql`
  mutation InviteUser($input: InviteUserInput!) {
    inviteUser(input: $input)
  }
`;

export const ACTIVATE_USER_MUTATION = gql`
  mutation ActivateUser($input: ActivateUserInput!) {
    activateUser(input: $input) {
      id
      email
      isActive
    }
  }
`;

export const DEACTIVATE_USER_MUTATION = gql`
  mutation DeactivateUser($input: DeactivateUserInput!) {
    deactivateUser(input: $input) {
      id
      email
      isActive
    }
  }
`;

export const CREATE_AND_INVITE_USER_MUTATION = gql`
  mutation CreateAndInviteUser($input: CreateAndInviteUserInput!) {
    createAndInviteUser(input: $input) {
      id
      email
      teamId
      appTeams {
        id
        name
      }
      organizationalRole
      isActive
    }
  }
`;

export const UPDATE_USER_MUTATION = gql`
  mutation UpdateUser($id: String!, $input: UpdateUserInput!) {
    updateUser(id: $id, input: $input) {
      id
      email
      firstName
      lastName
      isActive
      teamId
      appTeams {
        id
        name
      }
      organizationalRole
    }
  }
`;